export const ELang = {
  Kr: 'kr',
  En: 'en',
  Jp: 'jp',
} as const;

export type ELang = (typeof ELang)[keyof typeof ELang];
